export default "__VITE_ASSET__DEtNa3J4__"